import type { EventListenerList } from "../event"
import type { ActionBindingEvent } from "./ActionBindingEvent.type"
import type { InputActionType } from "./InputActionType"

export const inputRouterMap = new Map<InputActionType, EventListenerList<ActionBindingEvent>>()
